/* eslint-disable better-mutation/no-mutation */
const errors = {
    noShipping: 'syi_validation_shipping_no_shipping',
    empty: 'syi_validation_shipping_enter_method_and_cost',
    invalid: 'syi_validation_shipping_method_invalid',
    duplicate: 'syi_validation_shipping_method_identical',
    weight: 'syi_validation_shipping_enter_weight'
};

export function validate(newState) {
    if (!newState.offerTakeaway && !newState.offerShipping) {
        newState.globalValidationError = errors.noShipping;
        newState.validationErrors = {
            global: errors.noShipping
        };
        return newState;
    }

    newState.globalValidationError = null;
    newState.validationErrors = {};

    return newState;
}
